// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import {Injectable} from '@angular/core';
import {
        CreateCustomerRequest,
        CreateCustomerResponse,
        GetOptionsRequest,
        GetOptionsResponse,
} from './objects/';
import {
        CreateCustomerRequestInterface,
        CreateCustomerResponseInterface,
        GetOptionsRequestInterface,
        GetOptionsResponseInterface,
} from './interfaces/';
import {HttpHeaders, HttpClient, HttpResponse} from '@angular/common/http';
import {HostService} from '../_generated/host.service';
import {Observable} from 'rxjs';
import {map, share} from 'rxjs/operators';

@Injectable()
export class ContractBillingApiService {

    constructor(private http: HttpClient, private hostService: HostService) {
    }

    private apiOptions(): {headers: HttpHeaders, withCredentials: boolean} {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            withCredentials: true
        };
    }

    getOptions(r: GetOptionsRequest | GetOptionsRequestInterface): Observable<GetOptionsResponse> {
        const request = ((<GetOptionsRequest>r).toApiJson) ? (<GetOptionsRequest>r) : new GetOptionsRequest(r);
        return this.http.post<GetOptionsResponseInterface>(this.hostService.hostWithScheme() + "/contract_billing.v1.ContractBilling/GetOptions", request.toApiJson(), this.apiOptions())
            .pipe(
                map(resp => GetOptionsResponse.fromProto(resp)),
                share()
            );
    }
    createCustomer(r: CreateCustomerRequest | CreateCustomerRequestInterface): Observable<CreateCustomerResponse> {
        const request = ((<CreateCustomerRequest>r).toApiJson) ? (<CreateCustomerRequest>r) : new CreateCustomerRequest(r);
        return this.http.post<CreateCustomerResponseInterface>(this.hostService.hostWithScheme() + "/contract_billing.v1.ContractBilling/CreateCustomer", request.toApiJson(), this.apiOptions())
            .pipe(
                map(resp => CreateCustomerResponse.fromProto(resp)),
                share()
            );
    }
    
}
